<template>
    <div id="app">
        <b-navbar spaced>
            <template slot="brand">
                <b-navbar-item tag="router-link" :to="{ path: '/' }">
                    <div class="title is-4">MDBE tests</div>
                </b-navbar-item>
            </template>
            <template slot="start">
                <b-navbar-item tag="router-link" :to="{ name: 'TestRunIndex' }">
                    Test cases
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'ColumnstoreWeeklyReleaseTests' }">
                    Columnstore weekly release tests
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'UploadRequestResultsIndex' }">
                    Upload requests
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'TargetBuildPlatformSummary' }">
                    Platforms
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'TargetBuildHistory' }">
                    History
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'LogsSearch' }">
                    Logs
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'ManualUpload' }">
                    <b-icon icon="cloud-upload" style="margin-right: 0.4em"/>
                    Upload test results
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'XmlUploadRequestsIndex' }">
                    Uploads history
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'AboutPage' }">
                    About
                </b-navbar-item>
                <b-navbar-item href="/server/platform_editor" target="_blank">
                    Platform editor
                </b-navbar-item>
            </template>
            <template #end>
                <b-navbar-item tag="div">
                    <div class="buttons">
                        <b-button @click="logout" type="is-light" v-if="shouldShowLogoutButton">
                            Sign out
                        </b-button>
                    </div>
                </b-navbar-item>
            </template>
        </b-navbar>
        <b-notification v-if="noAccess" type="is-danger is-light">
            <p>You do not have access to the visualizer functions.</p>
            <p>Please, login with your <i>@mariadb.com</i> account.</p>
        </b-notification>
        <div class="container is-fluid" v-if="hasAccess">
            <router-view/>
        </div>

        <b-modal class="sign-in-modal" :active="shouldShowLogin">
            <SignInPage />
        </b-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import SignInPage from '@/views/SignInPage';
    export default {
        name: "App",
        computed: {
            ...mapGetters('Auth', [
                'shouldShowLogin',
                'shouldShowLogoutButton',
                'noAccess',
                'hasAccess',
                'error'
            ]),
        },
        methods: {
            ...mapActions('Auth', [
                'logout',
                'checkAuth'
            ]),
        },
        components: {
            SignInPage,
        },
        created() {
            this.checkAuth();
        }
    }
</script>

<style lang="scss">
/*@import url(~/styles/imports.scss);*/
    .sign-in-modal>.modal-content {
        background-color: #fff;
        padding: 4em;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: auto !important;
    }
</style>
